import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Cascader } from 'antd';
import { isEmpty } from 'lodash';

import { unflattenEntities } from '../Tree/treeUtils';
import s from './SectionSelector.pcss';


export function getSectionPath(section, items) {
  if (isEmpty(section)) return [];
  let sectionPath = [section];
  let currentSection = section;
  let parent = items.find(item => item.id === currentSection.parentSectionId);
  while (parent) {
    currentSection = parent;
    parent = items.find(item => item.id === currentSection.parentSectionId); // eslint-disable-line
    sectionPath = [currentSection].concat(sectionPath);
  }
  return sectionPath;
}

class SectionSelector extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    section: PropTypes.shape().isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  handleMenuItemClick = (selected) => {
    const section = this.props.items.find(item => item.id === selected[selected.length - 1]);
    if (!selected.length) {
      this.changeSection(undefined);
      return;
    }
    if (!section.isLocked) {
      this.changeSection(section.id);
    }
  };

  changeSection = (sectionId) => {
    const section = this.props.items.find(item => item.id === sectionId);
    this.props.onSelect(section || {});
  };

  renderOption = item => (
    <div
      className={s.submenuItem}
    >
      <div className={s.itemName}>{item.name}</div>
      {item.isLocked &&
        <div className={s.lockedIcon} />
      }
    </div>
  );

  displayRender = (labels, selectedOptions) =>
    selectedOptions.map(opt => opt.name).join(' -> ');

  render() {
    const { items, section } = this.props;
    const sectionPath = getSectionPath(section, items);
    const value = sectionPath.map(sec => sec.id);
    const formatedItems = items.reduce((result, item) => (
      item.weightIndex < 5 ? result.concat({
        id: item.id,
        value: item.id,
        name: item.name,
        label: this.renderOption(item),
        parentSectionId: item.parentSectionId,
      }) : result
    ), []);

    const options = unflattenEntities(formatedItems, 'id', 'parentSectionId');
    return (
      <div className={s.sectionContainer}>
        <div className={s.inputLabel}>Раздел</div>
        <Cascader
          options={options}
          value={value}
          changeOnSelect
          onChange={this.handleMenuItemClick}
          displayRender={this.displayRender}
          expandTrigger="hover"
          placeholder="Выберите секцию"
          getPopupContainer={triggerNode => triggerNode}
        />
      </div>
    );
  }
}

export default SectionSelector;



// WEBPACK FOOTER //
// ./src/shared/components/SectionSelector/index.js